<template>
  <div>
    <ul class="bottom-navigation">
      <li class="nav-item">
        <router-link :to="{ name: 'home' }">
          <img src="@/assets/icons/home.svg" />
        </router-link>
      </li>
      <li v-if="can('create-patient,view-patient')" class="nav-item">
        <router-link :to="{ name: 'registration' }">
          <img src="@/assets/icons/report.svg" />
        </router-link>
      </li>
      <li v-if="can('entry-checkup')" class="nav-item">
        <router-link :to="{ name: 'diseases-factors' }">
          <img src="@/assets/icons/beer.svg" />
        </router-link>
      </li>
      <li v-if="can('entry-checkup')" class="nav-item">
        <router-link :to="{ name: 'measurement' }">
          <img src="@/assets/icons/ruler.svg" />
        </router-link>
      </li>
      <li v-if="can('entry-checkup')" class="nav-item">
        <router-link :to="{ name: 'checkup' }">
          <img src="@/assets/icons/flask.svg" />
        </router-link>
      </li>
      <li v-if="can('entry-checkup')" class="nav-item">
        <router-link :to="{ name: 'consultation' }">
          <img src="@/assets/icons/consultation.svg" />
        </router-link>
      </li>
      <li class="nav-item">
        <a href="#" @click="openSettingBottomSheet">
          <img src="@/assets/icons/menu.svg" />
        </a>
      </li>
    </ul>
    <bottom-sheet
      :show.sync="settingBottomSheet"
      :on-close="closeSettingBottomSheet"
    >
      <span slot="title">Lainnya</span>
      <div slot="content">
        <ul class="list-menu">
          <li v-if="can('view-report')" @click="gotoReportPage" class="pointer">
            <material-icon name="show_chart" size="20" /> Rekapitulasi
          </li>
          <li
            v-if="can('create-operator,view-operator')"
            @click="gotoOperatorPage"
            class="pointer"
          >
            <material-icon name="supervisor_account" size="20" /> Operator
          </li>
          <li @click="gotoSettingPage" class="pointer">
            <material-icon name="person" size="20" /> Profil & Pengaturan
          </li>
          <li
            v-if="
              can(
                'view-mental-health-participant,update-mental-health-checkup,create-mental-health-schedule,update-mental-health-schedule,delete-mental-health-schedule'
              )
            "
            class="header"
          >
            Layanan Konsultasi Psikologi
          </li>
          <li
            v-if="
              can('view-mental-health-participant,update-mental-health-checkup')
            "
            @click="gotoMentalHealthPage"
            class="pointer"
          >
            <material-icon name="psychology" type="rounded" size="20" />
            Pendaftar
          </li>
          <li
            v-if="
              can(
                'create-mental-health-schedule,update-mental-health-schedule,delete-mental-health-schedule'
              )
            "
            @click="gotoMentalHealthSchedulePage"
            class="pointer"
          >
            <material-icon name="calendar_month" type="outlined" size="20" />
            Jadwal Konsultasi
          </li>
          <li
            v-if="
              can(
                'create-mental-health-room,update-mental-health-room,delete-mental-health-room'
              )
            "
            @click="gotoMentalHealthRoomPage"
            class="pointer"
          >
            <material-icon name="chair" type="outlined" size="20" />
            Ruang
          </li>
          <li
            v-if="
              can(
                'create-mental-health-psychologist,update-mental-health-psychologist'
              )
            "
            @click="gotoMentalHealthPsychologistPage"
            class="pointer"
          >
            <material-icon name="assignment_ind" type="outlined" size="20" />
            Psikolog
          </li>
          <li @click="doLogout" class="pointer text-danger">
            <material-icon name="exit_to_app" size="20" /> Keluar
          </li>
        </ul>
      </div>
    </bottom-sheet>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "base-layout-bottom-navigation",
  data: function () {
    return {
      settingBottomSheet: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "user",
    }),
  },
  methods: {
    openSettingBottomSheet: function () {
      this.settingBottomSheet = true;
    },
    closeSettingBottomSheet: function () {
      this.settingBottomSheet = false;
    },
    doLogout: function () {
      this.$store
        .dispatch("logout")
        .then(() => {
          this.$router.replace({ name: "auth" });
        })
        .catch(() => {
          this.$toasted.error("Gagal! Terjadi kesalahan.");
        });
    },
    gotoOperatorPage: function () {
      this.closeSettingBottomSheet();
      this.$router.push({ name: "operator-list" });
    },
    gotoSettingPage: function () {
      this.closeSettingBottomSheet();
      this.$router.push({ name: "profile" });
    },
    gotoReportPage: function () {
      this.closeSettingBottomSheet();
      this.$router.push({ name: "report" });
    },
    gotoMentalHealthPage: function () {
      this.closeSettingBottomSheet();
      this.$router.push({ name: "mental-health-participant" });
    },
    gotoMentalHealthSchedulePage: function () {
      this.closeSettingBottomSheet();
      this.$router.push({ name: "mental-health-schedule-list" });
    },
    gotoMentalHealthRoomPage: function () {
      this.closeSettingBottomSheet();
      this.$router.push({ name: "mental-health-room-list" });
    },
    gotoMentalHealthPsychologistPage: function () {
      this.closeSettingBottomSheet();
      this.$router.push({ name: "mental-health-psychologist-list" });
    },
  },
};
</script>
